import { useEffect, useRef } from "react";
import { trackViewItemList, normalizeProducts } from "./dataLayer";

/**
 * Fires view_item_list once per unique list signature when products arrive.
 */
export default function useTrackItemList(products, item_list_id, item_list_name) {
  const lastKey = useRef("");

  useEffect(() => {
    if (!products?.length) return;
    const items = normalizeProducts(products, { item_list_id, item_list_name });
    if (!items.length) return;
    const key = `${item_list_id || ""}|${item_list_name || ""}|${items
      .map((i) => i.item_id)
      .join(",")}`;
    if (key === lastKey.current) return;
    lastKey.current = key;
    trackViewItemList({ item_list_id, item_list_name, items });
  }, [products, item_list_id, item_list_name]);
}
